import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ApiTest: React.FC = () => {
  const theme = useTheme();
  const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001';
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testConnection = async () => {
    setLoading(true);
    setResult('Testing connection...');
    
    try {
      // Login first
      const loginResponse = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: 'test@example.com',
          password: 'TestPassword123'
        })
      });
      
      const loginData = await loginResponse.json();
      const token = loginData.token;
      setResult(`Login: ${JSON.stringify(loginData, null, 2)}`);
      
      // Test families
      const familiesResponse = await fetch(`${API_BASE_URL}/api/family/list`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const familiesData = await familiesResponse.json();
      setResult(prev => prev + '\n\nFamilies: ' + JSON.stringify(familiesData, null, 2));
      
      // Test children if family exists
      if (familiesData.length > 0) {
        const familyId = familiesData[0].id;
        const childrenResponse = await fetch(`${API_BASE_URL}/api/family/${familyId}/children`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        const childrenData = await childrenResponse.json();
        setResult(prev => prev + '\n\nChildren: ' + JSON.stringify(childrenData, null, 2));
        
        // Test behavior recording if children exist
        if (childrenData.length > 0) {
          const childId = childrenData[0].id;
          const behaviorResponse = await fetch(`${API_BASE_URL}/api/behavior/${childId}/record`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              behaviorType: 1
            })
          });
          const behaviorText = await behaviorResponse.text();
          setResult(prev => prev + '\n\nBehavior test: ' + behaviorText);
        }
      }
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : String(error);
      setResult(`Connection failed: ${message}`);
      console.error('API Test Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ padding: '20px', fontFamily: 'monospace' }}>
      <h3>API Connection Test</h3>
      <Box
        component="button"
        onClick={testConnection}
        disabled={loading}
        sx={{
          padding: '10px 20px',
          backgroundColor: theme.palette.info.main,
          color: 'white',
          border: 'none',
          borderRadius: 5 / 12, // theme.shape.borderRadius(12) * (5/12) = 5px
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Testing...' : 'Test API Connection'}
      </Box>

      {result && (
        <Box
          component="pre"
          sx={{
            marginTop: '20px',
            padding: '15px',
            backgroundColor: theme.palette.grey[100],
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: 5 / 12, // theme.shape.borderRadius(12) * (5/12) = 5px
            fontSize: '12px',
            whiteSpace: 'pre-wrap',
            maxHeight: '400px',
            overflow: 'auto'
          }}
        >
          {result}
        </Box>
      )}
    </Box>
  );
};

export default ApiTest;